<template>
    <div v-if="!isMobile" class="marquesList">
        <div class="router">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">{{ langPage['boa-manager-pays']['TXT_accueil'] }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ langPage['v4-marqueslist']['TXT_lesmarques'] }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <h3 class="title">{{ langPage['v4-marqueslist']['TXT_lesmarques'] }} ({{ count }})</h3>
        <div class="marquesFilter">
            <el-select class="filterSel1" @change="cateChange" v-model="cateVal"
                       :placeholder="langPage['vendeurs-menuvendeurscategories']['TXT_categories']" clearable>
                <el-option
                    v-for="item in cateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-select @change="typeChange" class="filterSel2" v-model="typeVal"
                       :placeholder="langPage['v4-topmenu']['TXT_type']"
                       clearable>
                <el-option
                    v-for="item in typeList"
                    :key="item.index"
                    :label="item.key"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-input class="search" v-model="keywords" v-on:keyup.native.enter="kwSearch"
                      :placeholder="langPage['catalogue-filtres-mods-vendeursmarques']['TXT_recherchermarque']">
                <i @click="kwSearch" slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <div v-loading="loading" class="marquesFilter">
            <div class="line">
                <div v-for="(condition,i) in condiList" @click="condChange(condition,i)"
                     :class="{condition:true,act:condIndex === i}">
                    {{ condition }}
                </div>
            </div>
        </div>
        <div class="listBox">
            <div class="marquesBox" v-for="marques in marquesList">
                <div class="mtitle" @click="onMarquesClick(marques)"
                     style="cursor: pointer;text-overflow: ellipsis;overflow:hidden;white-space:nowrap;">
                    <div class="loveBtn" @click.stop="onAddOrDelCollection(marques)">
                        <img v-if="marques.vendeurs_marques[0].favoris" src="@/assets/img/loving_heart.svg" alt="">
                        <img v-else src="@/assets/img/loving_heart_n.svg" alt="">
                    </div>
                    {{ marques.nomBoutique }}
                </div>
                <div class="mcontent">
                    <div class="name">{{ langPage['catalogue-filtresrecherche']['TXT_vendeur'].toUpperCase() }}</div>
                    <div class="value" style="text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">
                        {{ marques.vendeurs_marques[0].nom_marque }}
                    </div>
                    <div class="name">{{ langPage['vendeurs-informations']['TXT_membredepuisle'].toUpperCase() }}</div>
                    <div class="value">{{ marques.dateCreation | formatDate('{d}-{m}-{y}') }}</div>
                    <div class="name">{{ langPage['v4-marqueslist']['TXT_dernieremiseajour'].toUpperCase() }}</div>
                    <div class="value">
                        {{ marques.vendeurs_datum.last_update_produits_time |formatDate('{d}-{m}-{y}') }}
                    </div>
                    <div class="name">{{ langPage['v4-marqueslist']['TXT_commandeminimum'].toUpperCase() }}</div>
                    <div class="value">{{ marques.commandeMini ? marques.commandeMini + '€' : '-' }}</div>
                    <div class="tag exclusif" v-show="marques.exclusif">{{
                            langPage['v4-marqueslist']['TXT_exclusif']
                        }}
                    </div>
                    <div class="tag nouveau" v-show="isNewSeller(marques)">{{
                            langPage['v4-marqueslist']['TXT_nouveau']
                        }}
                    </div>
                    <div class="tag nouveau" style="visibility:hidden;"></div><!--留空，如果有的商家没有标签导致图片异常-->
                </div>
            </div>
        </div>
    </div>
    <div v-else class="mmarquesList mobileCommon">
        <h3 class="title">{{ langPage['v4-marqueslist']['TXT_lesmarques'] }} ({{ count }})</h3>
        <div class="marquesFilter">
            <el-select class="filterSel1" @change="cateChange" v-model="cateVal"
                       :placeholder="langPage['filtres']['TXT_categories']" clearable>
                <el-option
                    v-for="item in cateList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-select @change="typeChange" class="filterSel2" v-model="typeVal"
                       :placeholder="langPage['v4-topmenu']['TXT_type']"
                       clearable>
                <el-option
                    v-for="item in typeList"
                    :key="item.index"
                    :label="item.key"
                    :value="item.value">
                </el-option>
            </el-select>
            <el-input class="search" v-model="keywords" v-on:keyup.native.enter="kwSearch"
                      :placeholder="langPage['catalogue-filtres-mods-vendeursmarques']['TXT_recherchermarque']">
                <i @click="kwSearch" slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <div v-loading="loading" class="marquesFilter">
            <div class="line">
                <div v-for="(condition,i) in condiList" @click="condChange(condition,i)"
                     :class="{condition:true,act:condIndex === i}">
                    {{ condition }}
                </div>
            </div>
        </div>
        <div class="listBox">
            <div class="marquesBox" v-for="marques in marquesList">
                <div class="mtitle" @click="onMarquesClick(marques)"
                     style="cursor: pointer;text-overflow: ellipsis;overflow:hidden;white-space:nowrap;">
                    <div class="loveBtn" @click.stop="onAddOrDelCollection(marques)">
                        <img v-if="marques.vendeurs_marques[0].favoris" src="@/assets/img/loving_heart.svg" alt="">
                        <img v-else src="@/assets/img/loving_heart_n.svg" alt="">
                    </div>
                    {{ marques.nomBoutique }}
                </div>
                <div class="mcontent">
                    <div class="name">{{ langPage['catalogue-filtresrecherche']['TXT_vendeur'] | uppercase }}</div>
                    <div class="value" style="text-overflow:ellipsis;overflow:hidden;white-space:nowrap;">
                        {{ marques.vendeurs_marques[0].nom_marque }}
                    </div>
                    <div class="name">{{ langPage['vendeurs-informations']['TXT_membredepuisle'] | uppercase }}</div>
                    <div class="value">{{ marques.dateCreation | formatDate('{d}-{m}-{y}') }}</div>
                    <div class="name">{{ langPage['v4-marqueslist']['TXT_dernieremiseajour'] | uppercase }}</div>
                    <div class="value">
                        {{ marques.vendeurs_datum.last_update_produits_time |formatDate('{d}-{m}-{y}') }}
                    </div>
                    <div class="name">{{ langPage['v4-marqueslist']['TXT_commandeminimum'] | uppercase }}</div>
                    <div class="value">{{ marques.commandeMini ? marques.commandeMini + '€' : '-' }}</div>
                    <div class="tag exclusif" v-show="marques.exclusif">{{
                            langPage['v4-marqueslist']['TXT_exclusif']
                        }}
                    </div>
                    <div class="tag nouveau" v-show="isNewSeller(marques)">{{
                            langPage['v4-marqueslist']['TXT_nouveau']
                        }}
                    </div>
                    <div class="tag nouveau" style="visibility:hidden;"></div><!--留空，如果有的商家没有标签导致图片异常-->
                </div>
            </div>
        </div>
    </div>
</template>
<script>
let formatUtls = require('../utils/format')
export default {
    name: "marquesList",
    filters: {
        formatDate: formatUtls.parseTime,
        uppercase(val) {
            if (!val) return "";
            return val.toUpperCase();
        }
    },
    data() {
        let letterStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
            letterArr = letterStr.split('')
        letterArr.unshift('1-9')
        letterArr.unshift(this.$store.state.langPage['v4-lastthing']['TXT_tout']);
        return {
            isMobile: this.$store.state.isMobile,
            count: 0,
            cateList: [{
                // value: 11,
                // label: 'Femme',
            }],
            typeList: [
                {
                    value: 'exclusif',
                    key: this.$store.state['langPage']['v4-marqueslist']['TXT_exclusif']
                },
                {
                    value: 'nouveau',
                    key: this.$store.state['langPage']['v4-marqueslist']['TXT_nouveau']
                }
            ],
            condiList: letterArr,
            condIndex: 0,
            marquesList: [],
            params: {},
            cateVal: '',
            typeVal: '',
            keywords: '',
            loading: false,
        };
    },
    computed: {
        langPage() {
            return this.$store.state['langPage']
        }
    },
    methods: {
        load() {
            this.loading = true;
            this.getCategories();
            this.$api.vendeurs.list(this.params).then(res => {
                this.loading = false;
                let data = res.data;
                this.count = data.count;
                this.marquesList = null;
                this.marquesList = data.result;
            })
        },
        getCategories() {
            let menuData = this.$store.state.categories;
            //保留到第二层的类型
            let tempCate = [];
            let keys1Temp = Object.keys(menuData);
            keys1Temp.forEach(key => {
                //key 11; 要转成[{value:1101,lable:top}]
                // let obj = {
                //     value :menuData[key].id_categorie,
                //     label :menuData[key][`categories_langues`][0].libelle
                // };
                // tempCate.push(obj);
                //第一层的名字
                let firstCateName = menuData[key][`categories_langues`][0].libelle;
                let keys2Temp = Object.keys(menuData[key].subcategories);
                keys2Temp.forEach(key2 => {
                    let subCate = menuData[key].subcategories[key2];
                    let obj2 = {
                        value: subCate.id_categorie,
                        label: `${firstCateName}:${subCate['categories_langues'][0].libelle}`
                    };
                    tempCate.push(obj2);
                })
            });
            this.cateList = tempCate;
            this.$forceUpdate();
        },
        cateChange(val) {
            this.params.id_categorie = val
            this.load()
        },
        typeChange() {
            delete this.params.exclusif;
            delete this.params.new;
            if (this.typeVal === 'exclusif') {
                this.params.exclusif = 1
            } else if (this.typeVal === 'nouveau') {
                this.params.new = '1'
            }
            this.load()
        },
        condChange(val, i) {
            this.condIndex = i
            this.params.letter = val
            this.load()
        },
        kwSearch() {
            this.params.marques = this.keywords
            this.load()
        },
        love(item) {
            if (item.favoris) {
                delete item.favoris
            } else {
                item.favoris = 1
            }
            this.$api.vendeurs.collect(item.id_vendeur)
        },
        isNewSeller(seller) {
            let before1Month = new Date(Date.now() - (30 * 24 * 60 * 60 * 1000));
            let ctime = new Date(seller.dateCreation);
            return ctime.getTime() > before1Month.getTime();
        },
        //点击收藏或者取消收藏
        onAddOrDelCollection(marques) {
            if (!this.$store.state.token) {
                return this.$message.error(this.$t("seller_marques.word3"));
            }
            let params = {};
            params.id_vendeur = marques.id_vendeur;
            params.id_acheteur = localStorage.getItem("id_acheteur");
            let marqueIds = [];
            for (let marque of marques.vendeurs_marques) {
                marqueIds.push(marque.id_vendeur_marque);
            }
            params.id_vendeur_marques = marqueIds.join(',');
            this.$api.favor.addSellerMarques(params).then(res => {
                if (res.code !== 0) {
                    return this.$message.error(res.message);
                }
                if (res.data.supprimer === 0) {
                    this.$message.success(this.$t("seller_marques.word1"))
                } else {
                    this.$message.success(this.$t("seller_marques.word2"))
                }
                this.load()
            })
        },
        //品牌被点击
        onMarquesClick(marques) {
            if (this.$store.state.token) {
                this.$router.push(`/vendeur/${marques.id_vendeur}`);
            } else {
                this.$router.push(`/sign/choose`);
            }
        }
    },
    mounted() {
        this.params.id_acheteur = localStorage.getItem('id_acheteur')
        this.load()
    }

};
</script>
<style lang="less" scoped src="@/assets/viewCss/views/MarquesList.less">
</style>

